import React, { useState, useEffect } from 'react';
import { getTeam, inviteTeamMember, updateTeamMemberRole, removeTeamMember } from '../mocks/api';

export default function Team() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInvite, setShowInvite] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', role: 'viewer' });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    const data = await getTeam();
    setMembers(data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleInvite = async (e) => {
    e.preventDefault();
    setSaving(true);
    await inviteTeamMember(form);
    setForm({ name: '', email: '', role: 'viewer' });
    setShowInvite(false);
    setSaving(false);
    load();
  };

  const handleRoleChange = async (memberId, newRole) => {
    await updateTeamMemberRole(memberId, newRole);
    load();
  };

  const handleRemove = async (memberId) => {
    if (!window.confirm('Remove this team member?')) return;
    await removeTeamMember(memberId);
    load();
  };

  if (loading) return <div className="loading">Loading team...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h2>My Team</h2>
        <button className="btn btn-primary" onClick={() => setShowInvite(!showInvite)}>
          {showInvite ? 'Cancel' : '+ Invite Member'}
        </button>
      </div>

      {showInvite && (
        <div className="card form-card">
          <h3>Invite Team Member</h3>
          <form onSubmit={handleInvite}>
            <div className="form-row">
              <div className="form-group">
                <label>Full Name</label>
                <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. John Doe" />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input required type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="e.g. john@company.com" />
              </div>
              <div className="form-group">
                <label>Role</label>
                <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
                  <option value="viewer">Viewer</option>
                  <option value="operator">Operator</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
            </div>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Sending Invite...' : 'Send Invite'}
            </button>
          </form>
        </div>
      )}

      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Joined</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {members.map(m => (
              <tr key={m.id}>
                <td><strong>{m.name}</strong></td>
                <td>{m.email}</td>
                <td>
                  <select
                    className="role-select"
                    value={m.role}
                    onChange={e => handleRoleChange(m.id, e.target.value)}
                  >
                    <option value="viewer">Viewer</option>
                    <option value="operator">Operator</option>
                    <option value="admin">Admin</option>
                  </select>
                </td>
                <td><span className={`badge badge-${m.status}`}>{m.status}</span></td>
                <td>{m.joinedAt}</td>
                <td>
                  <button className="btn btn-sm btn-danger" onClick={() => handleRemove(m.id)}>Remove</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {members.length === 0 && <p className="empty-state">No team members yet.</p>}
      </div>
    </div>
  );
}
